import { Reducer } from 'redux';
import { Translations } from 'models/Translations';
import { ITranslationsActions, TranslationsActionType } from 'redux/actions/TranslationActions';

const initialState: Translations | null = null;
export const translationsReducer: Reducer<Translations | null, ITranslationsActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case TranslationsActionType.LOAD_TRANSLATIONS_DONE:
                {
                    return action.translations;
                }
            default:
                return state;
        }
    };
